module.exports = __webpack_public_path__ + "media/images/icons/trash-line-31d1bbb6d44a624a8db2d862234e2c8f.svg";